const debounce = () => {
  let timer;
  return (fn, delay) => {
    clearTimeout(timer);
    timer = setTimeout(fn, delay);
  };
};
export const debounceFunc = debounce();
